<script lang="ts">
	import Loader from 'components/Loader/Loader.svelte';
	import { _ } from 'utils/i18/i18n';

	export let dark = false;
	export let isLoading = false;
</script>

<div class="blured" class:dark>
	<div class="wrapper">
		<div class="loader-wrapper">
			<Loader />
			<p class="description">{$_('portfolio.recalculation')}</p>
		</div>
		<p class="text">{$_('portfolio.fewSecondsText')}</p>
	</div>
</div>

<style lang="scss">
	@import 'portfolioChartLoader';
</style>
